import React, { useContext, useEffect, useState } from "react"
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { CircularProgress } from '@mui/material'
import { CameraSx, GridLoadingSx, relativeGridSx, playIconSx, noCameraIconSx, cameraIconSx, textoCameraPrincipalSx, textoCameraSecundariaSx } from './CameraSx'
import { NoPhotography, PlayArrow, CameraAlt } from '@mui/icons-material'
import useCamera from '../../../hook/useCamera'
import { WebSocketContext } from '../../../Providers/WebSocket/WebSocketContext'
import { EventosContext } from '../../../Providers/EventosContext/EventosContext'
import { objIsEmpty, showNotify } from '../../../Utils/Utils'
import { iniciarTimerCamera } from '../GridCameras/timer'
import BenuvemPlayer from "./benuvemPlayer.jsx"

let retryCount = 0

export default function Camera({
    camera,
    cameraPrincipal = false
}) {
    return (
        <Grid sx={{ ...CameraSx, ...relativeGridSx }}>
            <CameraImage
                camera={camera}
                cameraPrincipal={cameraPrincipal}
            />

            {!cameraPrincipal &&
                <Grid sx={{ position: 'absolute', bottom: 0, right: 0, width: '100%' }}>
                    <span style={textoCameraSecundariaSx}>
                        {camera.nome_exibicao}
                    </span>
                </Grid>
            }

            {cameraPrincipal && <CameraControls camera={camera}/>}
        </Grid>
    )
}

const CameraImage = ({ camera, cameraPrincipal }) => {
    if (camera && camera.live_ws) {
        return <BenuvemPlayer style={CameraSx} url={camera.live_ws || ""} cameraPrincipal={cameraPrincipal} snapshot={camera.snapshot || ''}/>
    }

    const { isLoading, template, linkAux, setTemplate } = useCamera(camera, cameraPrincipal)

    const RetryFunc = () => {
        if (retryCount > 5) {
            setTemplate('error')
        } else {
            setTimeout(() => {
                retryCount++
                CameraImage({ camera, cameraPrincipal })
            }, 1000)
        }
    }

    if (template) {
        return (
            <CameraTemplate
                color={template}
            />
        )
    }

    if (isLoading) {
        return (
            <Grid sx={GridLoadingSx}>
                <CircularProgress />
            </Grid>
        )
    }

    return (
        <>
            {camera?.live_ws && <BenuvemPlayer style={CameraSx} url={camera.live_ws || ""} cameraPrincipal={cameraPrincipal} snapshot={camera.snapshot || ''}/> }

            {!camera?.url && linkAux && <img src={linkAux} alt="" style={CameraSx} onError={() => RetryFunc()} />}

            {!cameraPrincipal && <PlayIcon/>}
        </>
    )
}

const CameraTemplate = ({ color }) => {
    return (
        <Grid
            sx={{
                ...relativeGridSx,
                border: '1px solid white'
            }}
        >
            <NoPhotography
                sx={{ ...noCameraIconSx, color: (color == 'error' ? '#f00' : '#fff') }}
            />
        </Grid>
    )
}

const PlayIcon = () => {
    return (
        <Grid>
            <PlayArrow sx={playIconSx}/>
        </Grid>
    )
}

const CameraControls = ({ camera }) => {
    if (objIsEmpty(camera)) {
        return
    }

    const { eventoSelecionado } = useContext(EventosContext)
    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [live, setLive] = useState(true)

    useEffect(() => {
        iniciarAoVivo()
    }, [camera.id])

    const cameraId = camera.id

    const SnapshotIcon = () => {
        const getSnapshot = () => {
            const eventId = eventoSelecionado.id_one_log
            if (!eventId) {
                showNotify('error', 'Nenhum evento selecionado.')
                return
            }

            addRoute('getSnapshot', (msg) => {
                const { status, message } = msg.data

                if (status === 'error') {
                    showNotify(message)
                } else {
                    if (status) {
                        showNotify('success', 'Snapshot salvo com sucesso!')
                    }
                }
            })

            sendWs('getSnapshot', { cameraId, eventId })
        }

        return (
            <Grid onClick={getSnapshot}>
                <CameraAlt
                    sx={cameraIconSx}
                />
            </Grid>
        )
    }

    const iniciarAoVivo = () => {
        sendWs('pauseVideo', {})
        iniciarTimerCamera()
        setLive(true)
    }

    return (
        <Grid sx={{ position: 'absolute', width: '100%', height: '100%', top: 0 }}>
            <Grid sx={{
                display: 'flex',
                position: 'absolute',
                bottom: 0,
                width: '100%',
                justifyContent: 'center'
            }}>
                { camera.tipoCamera == 3
                    ? <Grid></Grid>
                    : <SnapshotIcon sx={cameraIconSx}/>
                }
            </Grid>
            <Grid sx={{ top: 0, display: 'flex', flexDirection: 'column' }}>
                {live
                    ? <span style={{ color: '#fff' }}>Ao vivo</span>
                    : <span style={{ color: '#f00' }}>Replay</span>}
                <span style={textoCameraPrincipalSx}>
                    {camera.nome_exibicao}
                </span>
            </Grid>
        </Grid>
    )
}
